var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-tmp" },
    [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "15px",
            color: "#1a1a1a",
            "font-weight": "600",
            "text-align": "center",
            padding: "15px 0"
          }
        },
        [_vm._v("工单凭单信息")]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("工单编号")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.no))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("工单类型")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.servcTypeMap[_vm.servcWorkVoucher.servcType]
                            ) + "\n\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("交易单号")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.tradeNo))]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("紧急状态")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.emgLevelMap[_vm.servcWorkVoucher.emgLevel]
                            ) + "\n\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("工单模式")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.servcWorkVoucher.grabFlag ? "抢单" : "指派"
                            ) + "\n\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("工单状态")]
                      ),
                      _vm._v(" "),
                      _vm.servcWorkVoucher.closed
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [_vm._v("已关闭")]
                          )
                        : _vm.servcWorkVoucher.invalid
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [_vm._v("已作废")]
                          )
                        : _vm.servcWorkVoucher.state == 7
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _vm._v(
                                "\n                        服务暂停(原因:' + " +
                                  _vm._s(_vm.servcWorkVoucher.stateDesc) +
                                  "+ '\n\n\n                    "
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.stateInfoMap[_vm.servcWorkVoucher.state]
                                )
                              )
                            ]
                          )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("请求单号")]
                      ),
                      _vm._v(" "),
                      _vm.servcWorkVoucher.reqVoucherId != null &&
                      _vm.servcWorkVoucher.reqVoucherId != -1
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.servcWorkVoucher.reqVoucherNo)
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("请求时间")]
                      ),
                      _vm._v(" "),
                      _vm.servcWorkVoucher.reqVoucherId != null &&
                      _vm.servcWorkVoucher.reqVoucherId != -1
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.servcWorkVoucher.requestTime))
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("工单创建时间\n\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.createTime))]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("工单创建人\n\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.creatorName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("指派网点\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _vm.servcWorkVoucher.servicerShopId == null
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _vm._v(
                                "\n                        未指派\n                    "
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.servcWorkVoucher.manualShopFlag
                                      ? "手工"
                                      : "自动"
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("指派工程师\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _vm.servcWorkVoucher.engineerId == null
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _vm._v(
                                "\n                        未指派\n                    "
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.servcWorkVoucher.manualEngFlag
                                      ? "手工"
                                      : "自动"
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("是否确定期保外\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _vm.servcWorkVoucher.beyondWrnt
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [_vm._v("交易约定外")]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [_vm._v("交易约定内")]
                          )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("仅报修人验收\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _vm.servcWorkVoucher.acceptByRequester
                        ? _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [_vm._v("是\n\n                    ")]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [_vm._v("否")]
                          )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("业务标签")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.retailerTag))]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c("div", { staticClass: "info-item clearfix" }, [
                    _c(
                      "div",
                      {
                        staticClass: "label",
                        staticStyle: {
                          width: "76px",
                          float: "left",
                          color: "#1a1a1a",
                          "font-weight": "600",
                          "white-space": "normal",
                          "word-break": "break-all"
                        }
                      },
                      [_vm._v("截止时间")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "value",
                        staticStyle: {
                          float: "left",
                          width: "-webkit-calc(100% - 86px)",
                          "white-space": "normal",
                          "word-break": "break-all"
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.servcWorkVoucher.yqFinishTime) +
                            "\n\n                    "
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              }),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("tbody", { staticClass: "body" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("系统编号")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.tmpNo || "无"))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("商品标识码\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.vendorUkno || "无")
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("设备名称")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.servcWorkVoucher.deviceName || "无") +
                              "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("设备分类")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.servcWorkVoucher.deviceCatName || "无"
                              ) +
                              "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("维保分组")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.servcWorkVoucher.devcGroupFullName || "无"
                              ) +
                              "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("设备品牌")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.servcWorkVoucher.deviceBrandName || "无"
                            ) + "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("所在部门")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.departName || "无")
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("部件名称")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        _vm._l(
                          _vm.servcWorkVoucher.servcWorkDeviceParts,
                          function(servcWorkDevicePart, index) {
                            return _c("span", [
                              _vm._v(_vm._s(servcWorkDevicePart.partName))
                            ])
                          }
                        )
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            { staticClass: "body" },
            [
              (_vm.servcWorkVoucher.servcWorkAccItemList != null &&
                _vm.servcWorkVoucher.servcWorkAccItemList.length > 0) ||
              (_vm.servcWorkVoucher.shareAccFlag &&
                _vm.servcWorkVoucher.servcWorkShareAccItemList != null &&
                _vm.servcWorkVoucher.servcWorkShareAccItemList.length > 0)
                ? _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px",
                          "text-align": "center",
                          color: "#1a1a1a",
                          "font-weight": "600",
                          "background-color": "#efefef",
                          "font-size": "12px"
                        },
                        attrs: { colspan: "3" }
                      },
                      [_vm._v("\n                配件信息\n\n\n            ")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.servcWorkVoucher.servcWorkAccItemList != null &&
              _vm.servcWorkVoucher.servcWorkAccItemList.length > 0
                ? _vm._l(_vm.servcWorkVoucher.servcWorkAccItemList, function(
                    servcWorkAccItem
                  ) {
                    return _c("tr", { staticClass: "row" }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c("div", { staticClass: "info-item clearfix" }, [
                            _c(
                              "div",
                              {
                                staticClass: "label",
                                staticStyle: {
                                  width: "76px",
                                  float: "left",
                                  color: "#1a1a1a",
                                  "font-weight": "600",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [_vm._v("配件名称\n\n\n                        ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  float: "left",
                                  width: "-webkit-calc(100% - 86px)",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(servcWorkAccItem.accName) +
                                    "\n\n\n                        "
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c("div", { staticClass: "info-item clearfix" }, [
                            _c(
                              "div",
                              {
                                staticClass: "label",
                                staticStyle: {
                                  width: "76px",
                                  float: "left",
                                  color: "#1a1a1a",
                                  "font-weight": "600",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [_vm._v("个数\n\n\n                        ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  float: "left",
                                  width: "-webkit-calc(100% - 86px)",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(servcWorkAccItem.quantity || "无") +
                                    "\n\n\n                        "
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c("div", { staticClass: "info-item clearfix" }, [
                            _c(
                              "div",
                              {
                                staticClass: "label",
                                staticStyle: {
                                  width: "76px",
                                  float: "left",
                                  color: "#1a1a1a",
                                  "font-weight": "600",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [_vm._v("单位\n\n\n                        ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  float: "left",
                                  width: "-webkit-calc(100% - 86px)",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(servcWorkAccItem.unit))
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.servcWorkVoucher.shareAccFlag &&
              _vm.servcWorkVoucher.servcWorkShareAccItemList != null &&
              _vm.servcWorkVoucher.servcWorkShareAccItemList.length > 0
                ? _vm._l(
                    _vm.servcWorkVoucher.servcWorkShareAccItemList,
                    function(servcWorkShareAccItem) {
                      return _c("tr", { staticClass: "row" }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [
                            _c("div", { staticClass: "info-item clearfix" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "label",
                                  staticStyle: {
                                    width: "76px",
                                    float: "left",
                                    color: "#1a1a1a",
                                    "font-weight": "600",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _vm._v(
                                    "配件名称\n\n\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    float: "left",
                                    width: "-webkit-calc(100% - 86px)",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(servcWorkShareAccItem.accName) +
                                      "\n\n\n                        "
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [
                            _c("div", { staticClass: "info-item clearfix" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "label",
                                  staticStyle: {
                                    width: "76px",
                                    float: "left",
                                    color: "#1a1a1a",
                                    "font-weight": "600",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [_vm._v("个数\n\n\n                        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    float: "left",
                                    width: "-webkit-calc(100% - 86px)",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        servcWorkShareAccItem.quantity || "无"
                                      ) +
                                      "\n\n\n                        "
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "1px solid #1a1a1a",
                              "vertical-align": "middle",
                              padding: "10px 4px"
                            }
                          },
                          [
                            _c("div", { staticClass: "info-item clearfix" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "label",
                                  staticStyle: {
                                    width: "76px",
                                    float: "left",
                                    color: "#1a1a1a",
                                    "font-weight": "600",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [_vm._v("单位\n\n\n                        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "value",
                                  staticStyle: {
                                    float: "left",
                                    width: "-webkit-calc(100% - 86px)",
                                    "white-space": "normal",
                                    "word-break": "break-all"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(servcWorkShareAccItem.unit))
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    }
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            staticStyle: {
                              width: "76px",
                              float: "left",
                              color: "#1a1a1a",
                              "font-weight": "600",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v("上门费（元）\n\n                    ")]
                        ),
                        _vm._v(" "),
                        _vm.servcWorkVoucher.toDoorFee != null
                          ? _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "76px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.servcWorkVoucher.toDoorFee) +
                                    "\n\n                    "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            staticStyle: {
                              width: "76px",
                              float: "left",
                              color: "#1a1a1a",
                              "font-weight": "600",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v("服务费（元）\n\n                    ")]
                        ),
                        _vm._v(" "),
                        _vm.servcWorkVoucher.finished
                          ? _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "76px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.servcWorkVoucher.generallFee || "无"
                                    ) +
                                    "\n\n                    "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "info-item ",
                        staticStyle: { overflow: "hidden" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            staticStyle: {
                              width: "76px",
                              float: "left",
                              color: "#1a1a1a",
                              "font-weight": "600",
                              "white-space": "normal",
                              "word-break": "break-all"
                            }
                          },
                          [_vm._v("配件费（元）\n\n                    ")]
                        ),
                        _vm._v(" "),
                        _vm.servcWorkVoucher.accFee != null &&
                        _vm.servcWorkVoucher.servcWorkAccItemList != null &&
                        _vm.servcWorkVoucher.servcWorkAccItemList.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "value",
                                staticStyle: {
                                  "padding-left": "76px",
                                  "white-space": "normal",
                                  "word-break": "break-all"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.servcWorkVoucher.accFee))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [
                    _c("div", { staticClass: "info-item clearfix" }, [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("总费用（元）\n\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            float: "left",
                            width: "-webkit-calc(100% - 86px)",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.servcWorkVoucher.amount) +
                              "\n\n\n                    "
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [
                    _c("div", { staticClass: "info-item clearfix" }, [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("sapn", [_vm._v("是否免费")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            float: "left",
                            width: "-webkit-calc(100% - 86px)",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.servcWorkVoucher.freeFlag
                            ? _c(
                                "span",
                                { staticClass: "swb-tags swb-tags-success" },
                                [_vm._v("免费")]
                              )
                            : _c(
                                "span",
                                { staticClass: "swb-tags swb-tags-danger" },
                                [_vm._v("收费")]
                              )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("td", {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                })
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("tbody", { staticClass: "body" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("服务请求方\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("请求机构")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerShopName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("请求人")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.requesterStaffName)
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("请求人电话\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.requesterContactTel)
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("请求地址")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.buyerShopAddr))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("请求机构联系电话\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.buyerShopContactTel)
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("请求描述")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.requestDesc || "无")
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("情况描述")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.troubleDesc))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("预约上门时间\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.planTime || "无"))]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        要求响应时间（分钟）\n\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.yqRspTimeMi || "无")
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        要求到达时间（分钟）\n\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.servcWorkVoucher.yqArriveTimeMi || "无"
                            ) + "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("要求完成时长(分钟)\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.servcWorkVoucher.yqRepairedTimeMi || "无"
                            ) + "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("计划出发时间\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.servcWorkVoucher.planStartOffTime || "无"
                            ) + "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("预计完成时间\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.servcWorkVoucher.estiFinishTime || "无"
                            ) + "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        实际响应时长（分钟）\n\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.rspTimeMi || "无"))]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        实际到达时长（分钟）\n\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.arriveTimeMi || "无") +
                              "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        实际完成时长（分钟）\n\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.servcWorkVoucher.repairedTimeMi || "无"
                            ) + "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        要求回询时限（分钟）\n\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.servcWorkVoucher.reqTelCallTimeMi || "无"
                            ) + "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        实际回询时限（分钟）\n\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.servcWorkVoucher.rspTelCallTimeMi || "无"
                            ) + "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              }),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("tbody", { staticClass: "body" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("服务商名称\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.servicerName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("服务网点名称\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.servcWorkVoucher.servicerShopName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("网点联系电话\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.servcWorkVoucher.servicerShopContractTel ||
                                  "无"
                              ) +
                              "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("网点联系人\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.servcWorkVoucher.servicerShopContractName ||
                                  "无"
                              ) +
                              "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              }),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("tbody", { staticClass: "body" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("主工程师")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.engineerName || "无")
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("辅助工程师\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.engineerNames || "无") +
                              "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("主工程师联系电话\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.contactTel || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("到达时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.toDoorTime || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              }),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              })
            ]),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("故障类型")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.faultTypeName || "无") +
                              "\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("故障描述\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.servcWorkVoucher.faultDesc || "无") +
                              "\n\n                    "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("维修类型\n\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.servcWorkVoucher.repairTypeName || "无"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("服务完成时间\n                    ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.finishTime || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("处理结果")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.servcWorkVoucher.handleResult || "无")
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.servcWorkVoucher.finished &&
      (_vm.servcWorkVoucher.servcType == 0 ||
        _vm.servcWorkVoucher.servcType == 1 ||
        _vm.servcWorkVoucher.additionFlag)
        ? [
            _c("swb-servc-work-add-item-list", {
              ref: "swb_servc_work_add_item_list",
              attrs: { id: _vm.voucherId }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.devcInspectFlag &&
      _vm.servcWorkVoucher.devcInspectInfo != null
        ? [
            _c(
              "div",
              {
                staticClass: "order-tmp-caption",
                staticStyle: {
                  "font-size": "15px",
                  color: "#1a1a1a",
                  "font-weight": "600",
                  "text-align": "center",
                  padding: "15px 0"
                }
              },
              [_vm._v("检验签字信息")]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "simple-tbl",
                staticStyle: {
                  width: "100%",
                  "table-layout": "fixed",
                  "border-collapse": "collapse",
                  "border-spacing": "2px",
                  "border-color": "gray",
                  color: "#666",
                  "font-size": "12px"
                }
              },
              [
                _c("tbody", { staticClass: "body" }, [
                  _c("tr", { staticClass: "row" }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c("div", { staticClass: "info-item clearfix" }, [
                          _vm._m(7),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                float: "left",
                                width: "-webkit-calc(100% - 160px)",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.servcWorkVoucher.devcInspectInfo
                                      .handoverOutRcvName
                                  )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "sign-name",
                            staticStyle: {
                              height: "160px",
                              "text-align": "center"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { height: "160px" },
                              attrs: {
                                src:
                                  _vm.servcWorkVoucher.devcInspectInfo
                                    .handoverOutRcvSigUrl
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item clearfix" }, [
                          _vm._m(8),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value align-right",
                              staticStyle: {
                                float: "left",
                                width: "-webkit-calc(100% - 86px)",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    new Date(
                                      _vm.servcWorkVoucher.devcInspectInfo.inspectDate
                                    ).format("yyyy年MM月dd日")
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px"
                        }
                      },
                      [
                        _c("div", { staticClass: "info-item clearfix" }, [
                          _vm._m(9),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                float: "left",
                                width: "-webkit-calc(100% - 160px)",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.servcWorkVoucher.devcInspectInfo
                                      .handoverInRcvName
                                  )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "sign-name",
                            staticStyle: {
                              height: "160px",
                              "text-align": "center"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { height: "160px" },
                              attrs: {
                                src:
                                  _vm.servcWorkVoucher.devcInspectInfo
                                    .handoverInRcvSigUrl
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item clearfix" }, [
                          _vm._m(10),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value align-right",
                              staticStyle: {
                                float: "left",
                                width: "-webkit-calc(100% - 86px)",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    new Date(
                                      _vm.servcWorkVoucher.devcInspectInfo.inspectDate
                                    ).format("yyyy年MM月dd日")
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.devcMaintFlag
        ? [
            _c("swb-servc-work-devc-maint-voucher-list", {
              ref: "swb_servc_work_devc_maint_voucher_list",
              attrs: { id: _vm.voucherId }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.servcWorkVoucher.servcType == 3
        ? [
            _c("swb-servc-work-check-voucher-voucher-list", {
              ref: "swb_servc_work_check_voucher_voucher_list",
              attrs: { id: _vm.voucherId }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_vm._v("\n                基本信息\n\n            ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_vm._v("\n                设备信息\n\n            ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_vm._v("\n                费用信息\n\n            ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_vm._v("\n                请求信息\n\n            ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_vm._v("\n                服务网点信息\n\n            ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_vm._v("\n                工程师信息\n\n            ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_vm._v("\n                处理信息\n\n            ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "160px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("交出接收人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("检验日期")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "160px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("交回接收人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("检验日期")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fc60a04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc60a04","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkVoucherDetailerForExport.vue
// module id = 2850
// module chunks = 0